import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { name: 'Login', path: '', component: () => import('pages/PageIndex.vue') },
      {
        name: 'RefreshLogin',
        path: '/refresh-login',
        component: () => import('pages/PageRefreshLogin.vue'),
      },
      {
        name: 'Teclado',
        path: '/teclado',
        component: () => import('pages/PageTeclado.vue'),
      },
      {
        name: 'Despesa',
        path: '/despesa',
        component: () => import('pages/PageDespesa.vue'),
      },
      {
        name: 'DespesaEdit',
        path: '/despesa/:id',
        component: () => import('pages/PageDespesa.vue'),
      },
      {
        name: 'MinhaConta',
        path: '/minha-conta',
        component: () => import('pages/PageMinhaConta.vue'),
      },
    ],
  },

  {
    path: '/d',
    component: () => import('layouts/DialogLayout.vue'),
    children: [
      {
        name: 'Despesas',
        path: '/d/despesas',
        component: () => import('pages/PageDespesas.vue'),
        meta: {
          title: 'Despesas',
          hideTitle: true
        }
      },
      {
        name: 'Atendimentos',
        path: '/d/atendimentos',
        component: () => import('pages/PageAtendimentos.vue'),
        meta: {
          title: 'Atendimentos',
          hideTitle: true
        }
      },
      {
        name: 'Atendimento',
        path: '/d/atendimento',
        component: () => import('pages/PageAtendimento.vue'),
        meta: {
          title: 'Atendimento',
        }
      },
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/PageError404.vue'),
  },
];

export default routes;
